import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import i18next from 'i18next'

import {  } from '../actions/api'
import { formatDateHistory, formatDateForCalendar, fromSeconds } from '../actions/helpers';
import { setCurrentClientState, setClientSelectedSnapshotIndex } from '../actions/localStates'

class ClientHistoryView extends Component {

	constructor(props) {
	    super(props);
	    this.state = {
	    	current_period: "seconds",
			displayed_value: 0
	    }

	    this.setShowSnapshotList = this.setShowSnapshotList.bind(this);
	    this.closeSnapshotList = this.closeSnapshotList.bind(this);

	    this.onSnapshotDateChanged = this.onSnapshotDateChanged.bind(this);
	    this.getPreviousSnapshot = this.getPreviousSnapshot.bind(this);
	    this.getNextSnapshot = this.getNextSnapshot.bind(this);
	    this.getFirstSnapshot = this.getFirstSnapshot.bind(this);

	    this.checkIfPasswordChanged = this.checkIfPasswordChanged.bind(this);
	}

	onSnapshotDateChanged (index) {
		var _this = this;
		var enquire = JSON.parse(_this.props.clientHistory.snapshotList[index].clientJson)
        _this.props.actions.setCurrentClientState(enquire)
		this.props.actions.setClientSelectedSnapshotIndex(index)
		this.setState({"modifyingDateTime": _this.props.clientHistory.snapshotList[index].modifyingDateTime})
		this.setState({"modifyingInitiatorId": _this.props.clientHistory.snapshotList[index].modifyingInitiatorId})
		
        this.setState({"snapshotDate": _this.props.clientHistory.snapshotList[index].modifyingDateTime})
    }

    checkIfPasswordChanged () {
    	if (this.props.clientHistory.selectedSnapshotIndex + 1 > this.props.clientHistory.snapshotList.length - 1) {
    		return false;
    	}

    	var prevEnquire = JSON.parse(this.props.clientHistory.snapshotList[this.props.clientHistory.selectedSnapshotIndex + 1].clientJson)

    	if (this.props.clientHistory.currentClientState !== null && this.props.clientHistory.currentClientState.password === prevEnquire.password) {
    		return false;
    	} else {
    		return true;
    	}
    	
    }

    getPreviousSnapshot () {
		var _this = this;
		var enquire, prevDate;
		if ((this.props.clientHistory.selectedSnapshotIndex + 1) < this.props.clientHistory.snapshotList.length) {
			enquire = JSON.parse(this.props.clientHistory.snapshotList[this.props.clientHistory.selectedSnapshotIndex + 1].clientJson)

			window.setTimeout(function () {
            	_this.props.actions.setCurrentClientState(enquire)
            }, 25)
			this.props.actions.setClientSelectedSnapshotIndex(this.props.clientHistory.selectedSnapshotIndex + 1)
			prevDate = this.props.actions.formatDateForCalendar(this.props.clientHistory.snapshotList[this.props.clientHistory.selectedSnapshotIndex + 1].modifyingDateTime)
			this.setState({"modifyingDateTime": this.props.clientHistory.snapshotList[this.props.clientHistory.selectedSnapshotIndex + 1].modifyingDateTime})
			this.setState({"modifyingInitiatorId": this.props.clientHistory.snapshotList[this.props.clientHistory.selectedSnapshotIndex + 1].modifyingInitiatorId})
			// this.setState({"snapshotDate": prevDate})
		} else {
			enquire = JSON.parse(this.props.clientHistory.snapshotList[this.props.clientHistory.snapshotList.length - 1].clientJson)

			window.setTimeout(function () {
            	_this.props.actions.setCurrentClientState(enquire)
            }, 25)
			this.props.actions.setClientSelectedSnapshotIndex(this.props.clientHistory.snapshotList.length - 1)
			prevDate = this.props.actions.formatDateForCalendar(this.props.clientHistory.snapshotList[this.props.clientHistory.snapshotList.length - 1].modifyingDateTime)
			this.setState({"modifyingDateTime": this.props.clientHistory.snapshotList[this.props.clientHistory.snapshotList.length - 1].modifyingDateTime})
			this.setState({"modifyingInitiatorId": this.props.clientHistory.snapshotList[this.props.clientHistory.snapshotList.length - 1].modifyingInitiatorId})
			// this.setState({"snapshotDate": prevDate})
		}

		this.setState({"snapshotDate": prevDate})
	}
	
	getNextSnapshot () {
		var _this = this;
		var enquire, nextDate;
		if ((this.props.clientHistory.selectedSnapshotIndex - 1) <= 0) {
			enquire = JSON.parse(this.props.clientHistory.snapshotList[0].clientJson)

			window.setTimeout(function () {
            	_this.props.actions.setCurrentClientState(enquire)
            }, 25)
			
			this.props.actions.setClientSelectedSnapshotIndex(0)
			nextDate = this.props.actions.formatDateForCalendar(this.props.clientHistory.snapshotList[0].modifyingDateTime)
			this.setState({"modifyingDateTime": this.props.clientHistory.snapshotList[0].modifyingDateTime})
			this.setState({"modifyingInitiatorId": this.props.clientHistory.snapshotList[0].modifyingInitiatorId})
			// this.setState({"snapshotDate": nextDate})
		} else {
			enquire = JSON.parse(this.props.clientHistory.snapshotList[this.props.clientHistory.selectedSnapshotIndex - 1].clientJson)

			window.setTimeout(function () {
            	_this.props.actions.setCurrentClientState(enquire)
            }, 25)
			this.props.actions.setClientSelectedSnapshotIndex(this.props.clientHistory.selectedSnapshotIndex - 1)
			nextDate = this.props.actions.formatDateForCalendar(this.props.clientHistory.snapshotList[this.props.clientHistory.selectedSnapshotIndex - 1].modifyingDateTime)
			this.setState({"modifyingDateTime": this.props.clientHistory.snapshotList[this.props.clientHistory.selectedSnapshotIndex - 1].modifyingDateTime})
			this.setState({"modifyingInitiatorId": this.props.clientHistory.snapshotList[this.props.clientHistory.selectedSnapshotIndex - 1].modifyingInitiatorId})
			// this.setState({"snapshotDate": nextDate})
		}

		this.setState({"snapshotDate": nextDate})
	}

	getFirstSnapshot () {
		var _this = this;
		var enquire = JSON.parse(this.props.clientHistory.snapshotList[0].clientJson)

		window.setTimeout(function () {
        	_this.props.actions.setCurrentClientState(enquire)
        }, 25)
		this.props.actions.setClientSelectedSnapshotIndex(0)
	}

	componentDidMount() {
		var _this = this;
		if (this.props.clientHistory.currentClientState !== null && this.props.clientHistory.currentClientState.tokenExpiredAfterSec > 0) {
			window.setTimeout(function () {
				var curr_date = _this.props.actions.fromSeconds(_this.props.clientHistory.currentClientState.tokenExpiredAfterSec)
				_this.setState({"displayed_value": curr_date.value})
				_this.setState({"current_period": curr_date.unit})
			}, 25)
		}
	}

	componentDidUpdate(prevProps) {
		var _this = this;
		if (prevProps.clientHistory !== this.props.clientHistory && this.props.clientHistory.currentClientState !== null && this.props.clientHistory.currentClientState.tokenExpiredAfterSec > 0) {
			var curr_date = _this.props.actions.fromSeconds(_this.props.clientHistory.currentClientState.tokenExpiredAfterSec)
			_this.setState({"displayed_value": curr_date.value})
			_this.setState({"current_period": curr_date.unit})
		}
    }

	componentWillUnmount() {

	}

	setShowSnapshotList (event) {
		event.preventDefault();
		this.setState({
				showSnapshotList: !this.state.showSnapshotList
			}, () => {
			document.addEventListener('click', this.closeSnapshotList);
		});
  	}

	closeSnapshotList(event) { 
		this.setState({ showSnapshotList: false }, () => {
			document.removeEventListener('click', this.closeSnapshotList);
		});  
	}

	render() {
		let showSnapshotListOpen = 'dropdown-menu'
	    if (this.state.showSnapshotList) {
	      showSnapshotListOpen = 'dropdown-menu show'
	    }

	    let activeClass  = "edit-view-history-single"
		if (this.props.base.drawerOpen) {
			activeClass = "edit-view-history-single open"
		}
		return (
			<div className="col-12" style={{paddingLeft: "0px", paddingRight: "0px"}}>
				{
					this.props.clientHistory.snapshotList.length > 0
					? <div style={{float: "right", marginLeft: "auto"}}>
						<div className="row no-right-padding">
							<div className="dropdown" style={{paddingLeft: "0px", paddingRight: "10px"}}>
                                <button className="btn btn-outline-info" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false" onClick={this.setShowSnapshotList}>
                                    <label className="text-overflow-label" style={{marginBottom: "0px"}}>{i18next.t("version")}{this.props.clientHistory.snapshotList.length - this.props.clientHistory.selectedSnapshotIndex}<span className="paddingLeft10">{i18next.t("dateTime")}</span>{this.props.actions.formatDateHistory(this.props.clientHistory.snapshotList[this.props.clientHistory.selectedSnapshotIndex] !== undefined ? this.props.clientHistory.snapshotList[this.props.clientHistory.selectedSnapshotIndex].modifyingDateTime : null)}<span className="paddingLeft10">{i18next.t("issuerLabel")}</span>{this.props.clientHistory.snapshotList[this.props.clientHistory.selectedSnapshotIndex] !== undefined ? this.props.clientHistory.snapshotList[this.props.clientHistory.selectedSnapshotIndex].modifyingInitiatorId : ""}</label>
                                </button>
                                <div className={showSnapshotListOpen} style={{width: "100%", overflowY: "auto", maxHeight: "500px", fontSize: "14px"}}>
                                    {
                                        <table className="table table-striped" style={{marginBottom: "0px"}}>
										  <tbody>
										    {this.props.clientHistory.snapshotList.map((snapshot, index) => (
										      <tr key={index} className="cursor-pointer" onClick={this.onSnapshotDateChanged.bind(this, index)}>
										        <td style={{paddingLeft: "5px", paddingRight: "0px"}}><span style={{fontWeight: "700"}}>{i18next.t("version")}</span>{(this.props.clientHistory.snapshotList.length - index)}</td>
										        <td style={{paddingLeft: "20px"}}><span style={{fontWeight: "700"}}>{i18next.t("dateTime")}</span>{this.props.actions.formatDateHistory(snapshot.modifyingDateTime)}</td>
										        <td style={{paddingLeft: "0px", paddingRight: "0px"}}><span style={{fontWeight: "700"}}>{i18next.t("issuerLabel")}</span>{snapshot.modifyingInitiatorId}</td>
										      </tr>
										    ))}
										  </tbody>
										</table>
                                    }
                                </div>
                            </div>

							<button className="btn btn-outline-info" title={i18next.t("actual")} style={{marginRight: "5px"}} disabled={this.props.clientHistory.selectedSnapshotIndex === 0 ? true : false} onClick={this.getFirstSnapshot}>{"|<"}</button>
	                        <button className="btn btn-outline-info" title={i18next.t("next")} style={{marginRight: "5px"}} disabled={this.props.clientHistory.selectedSnapshotIndex === 0 ? true : false} onClick={this.getNextSnapshot}>{"<"}</button>
	                        <button className="btn btn-outline-info" title={i18next.t("previous")} style={{marginRight: "5px"}} disabled={this.props.clientHistory.selectedSnapshotIndex === this.props.clientHistory.snapshotList.length - 1 ? true : false} onClick={this.getPreviousSnapshot}>{">"}</button>

	                    </div>
	                </div>
					: null
				}
				{
					this.props.clientHistory.snapshotList.length > 0
					? <div className={activeClass}>
						<div className="col-10">
							<div className="row col-12 equal-height-row">
								<div className="col-6 equal-height-col" style={{paddingLeft: "0px"}}>
									<label className="section-label">{i18next.t("formLabel")}</label>
									<div className="border-for-history equal-height-content">
										<label className="col-12 col-form-label" style={{fontSize: "15px", color: "#b5b1af", paddingBottom: "0px"}}>{i18next.t("uniqueIdLabel") + ": "}<span style={{color: "black"}}>{this.props.clientHistory.currentClientState !== null ? this.props.clientHistory.currentClientState.clientName : ""}</span></label>
										<label className="col-12 col-form-label" style={{fontSize: "15px", color: "#b5b1af", paddingBottom: "0px"}}>{i18next.t("userStatusLabel") + ": "}<span style={{color: "black"}}>{i18next.t(this.props.clientHistory.currentClientState !== null ? this.props.clientHistory.currentClientState.status : "")}</span></label>

										<label className="col-12 col-form-label" style={{fontSize: "15px", color: "#b5b1af", paddingBottom: "0px"}}>{i18next.t("clientNameLabel") + ": "}<span style={{color: "black"}}>{this.props.clientHistory.currentClientState !== null ? this.props.clientHistory.currentClientState.fullName : ""}</span></label>
										<label className="col-12 col-form-label" style={{fontSize: "15px", color: "#b5b1af", paddingBottom: "0px"}}>{i18next.t("emailLabel") + ": "}<span style={{color: "black"}}>{this.props.clientHistory.currentClientState !== null ? this.props.clientHistory.currentClientState.email : ""}</span></label>
										<label className="col-12 col-form-label" style={{fontSize: "15px", color: "#b5b1af", paddingBottom: "0px"}}>{i18next.t("advancedInfo") + ": "}<span style={{color: "black"}}>{this.props.clientHistory.currentClientState !== null ? this.props.clientHistory.currentClientState.extendedData : ""}</span></label>
										
										<label className="col-12 col-form-label" style={{fontSize: "15px", color: "#b5b1af", paddingBottom: "0px"}}>{i18next.t("activeTokensNumberTitle") + ": "}<span style={{color: "black"}}>{this.props.clientHistory.currentClientState !== null ? this.props.clientHistory.currentClientState.activeTokenNumber : ""}</span></label>
										<label className="col-12 col-form-label" style={{fontSize: "15px", color: "#b5b1af", paddingBottom: "0px"}}>{i18next.t("tokensExpiredAfterTitle") + ": "}<span style={{color: "black"}}>{this.state.displayed_value + " " + i18next.t(this.state.current_period)}</span></label>

										<label
											className="col-12 col-form-label"
											style={{ fontSize: "15px", color: "#b5b1af", paddingBottom: "0px" }}
										>
											{i18next.t("rolesLabel") + ": "}
											<span style={{color: "black"}}>
												{
													this.props.clientHistory.currentClientState !== null &&
													this.props.clientHistory.currentClientState.roles.length > 0 && (
																this.props.clientHistory.currentClientState.roles
																.map((role) => i18next.t(role))
																.join(", ")
												)}
											</span>
										</label>
										<label className="col-12 col-form-label" style={{fontSize: "15px", color: "#b5b1af", paddingBottom: "10px"}}>
											{i18next.t("passwordChanged") + ": "}
											<span style={{ color: "black" }}>{
												this.checkIfPasswordChanged() ? i18next.t("yes") : i18next.t("no")
											}</span>
										</label>
									</div>
								</div>
							</div>
						</div>
					  </div>
					: <div style={{textAlign: "center"}}>
						<label>{i18next.t("noHistory")}</label>
					  </div>
				}
			</div>
		);
	}
}

function mapStateToProps(state) {
    return {
        base: state.base,
        tokens: state.tokensReducer,
        login: state.loginReducer,
        client: state.clientReducer,
        clientHistory: state.clientHistoryReducer
    }
}

const mapDispatchToProps = (dispatch) => {
    const actions = {
    	formatDateHistory, formatDateForCalendar, setCurrentClientState,
    	setClientSelectedSnapshotIndex, fromSeconds
    };
    return {
       actions: bindActionCreators(actions, dispatch)
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(ClientHistoryView);